/* eslint-disable import/no-extraneous-dependencies */
import { ReactElement, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { Alert } from '@components';
import { iThirdPartyFormValues } from '@services/ThirdPartyService';
import FormSubmissionSuccessAlertContent from '@components/Content/AlertContent/FormSubmissionSuccessAlertContent';
import DoneIcon from '../../../images/done.svg';
import styles from './TPStep7.module.scss';

function TPStep7(): ReactElement {
  const { values }: { values: iThirdPartyFormValues } = useFormikContext();
  const { resetForm }: { resetForm: any } = useFormikContext();
  const emailAddress = values.EmailAddressOptionalThree;
  const submissionNumber = values.submissionNo;
  const sendEmailCopy = values.EMAIL_TO;

  useEffect(() => {
    const handlePopstate = () => {
      // Check if the back button is clicked
      resetForm();
      };
    window.addEventListener('popstate', handlePopstate);
    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, []);

  return (
    <div className={styles.step7}>
      <div className="vfH2">Your application has been submitted</div>
      <Alert
        title="For your records"
        message={<FormSubmissionSuccessAlertContent submissionNumberAlertInfo={submissionNumber as string} email={emailAddress ? (emailAddress as string) : ''} hasEmailCopy={sendEmailCopy} />}
        icon={DoneIcon}
        theme="success"
        color="green"
      />
      <div className={styles.submissionBody}>
        <p>Once your application is processed, your nominee will be able to act or enquire on your behalf. This may take up to 14 days.</p>
        <p>
          You may revoke this authority at any time by contacting Fines Victoria on&nbsp;
          <a href="tel:+392008111">(03) 9200 8111</a>
          .
        </p>
        <a href="/">Close</a>
      </div>
    </div>
  );
}

export default TPStep7;
